import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useImagePreload } from "../../../../../hooks/index.js";
import { Box } from "../../../../../Box/index.js";
import { Skeleton } from "../../../../../Skeleton/index.js";
import { MediaEmpty } from "../../../../../MediaEmpty/index.js";
const ImageComponent = (t0)=>{
    const $ = c(18);
    const { alt, src, minHeight, maxHeight, width, hasError: t1 } = t0;
    const hasError = void 0 === t1 ? false : t1;
    const imageStatus = useImagePreload(src);
    const loadedImage = {
        loading: "loading" === imageStatus,
        fulfilled: "complete" === imageStatus,
        rejected: "failed" === imageStatus
    };
    if (loadedImage.fulfilled) {
        const t2 = loadedImage.fulfilled ? "bg.dark.primary" : "bg.light.primary";
        let t3;
        if ($[0] !== maxHeight || $[1] !== minHeight || $[2] !== width) {
            t3 = {
                maxWidth: width,
                maxHeight,
                minHeight,
                objectFit: "contain"
            };
            $[0] = maxHeight;
            $[1] = minHeight;
            $[2] = width;
            $[3] = t3;
        } else t3 = $[3];
        let t4;
        if ($[4] !== alt || $[5] !== src || $[6] !== t3) {
            t4 = /*#__PURE__*/ jsx("img", {
                src: src,
                alt: alt,
                style: t3
            });
            $[4] = alt;
            $[5] = src;
            $[6] = t3;
            $[7] = t4;
        } else t4 = $[7];
        let t5;
        if ($[8] !== t2 || $[9] !== t4 || $[10] !== width) {
            t5 = /*#__PURE__*/ jsx(Box, {
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: t2,
                maxWidth: width,
                width: "100%",
                overflow: "hidden",
                radius: "m",
                children: t4
            });
            $[8] = t2;
            $[9] = t4;
            $[10] = width;
            $[11] = t5;
        } else t5 = $[11];
        return t5;
    }
    if (loadedImage.rejected || hasError) {
        let t2;
        if ($[12] !== maxHeight || $[13] !== width) {
            t2 = /*#__PURE__*/ jsx(MediaEmpty, {
                height: maxHeight,
                width: width,
                radius: "m"
            });
            $[12] = maxHeight;
            $[13] = width;
            $[14] = t2;
        } else t2 = $[14];
        return t2;
    }
    let t2;
    if ($[15] !== maxHeight || $[16] !== width) {
        t2 = /*#__PURE__*/ jsx(Skeleton, {
            height: maxHeight,
            width: width,
            variant: "rect"
        });
        $[15] = maxHeight;
        $[16] = width;
        $[17] = t2;
    } else t2 = $[17];
    return t2;
};
export { ImageComponent };
